import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
        submitButton: {
           color:'#FFFFFF',
           "&:hover": {
            backgroundColor:'#0F7BBD',
        },
        },
}));